/**
 * Permanent visible-shell contract for Praxa Control.
 *
 * Increment this only when a reviewed product decision intentionally replaces
 * the command-center information architecture. It must never be used as a
 * runtime flag or as a path back to the retired feature-card dashboard.
 */
export const PRAXA_CONTROL_SHELL_VERSION = "command-center-v2" as const;

/**
 * The permanent macOS material paired with the command-center shell.
 *
 * Electron supplies the native vibrancy and the renderer supplies only
 * translucent pane tints. This is a contract marker, not a runtime toggle.
 */
export const PRAXA_CONTROL_MATERIAL_VERSION = "cursor-translucent-v1" as const;
